import React from 'react'
import Sectiontitle from '../section-title'
import penale from '../../images/aree/penale.jpg'
import './style.css'

const Story = () =>{
    return(
        <div id="competenza" className="story-area section-padding">
            <Sectiontitle section={'Penale'}/>
            <div className="container">
                <div className="story-wrap">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 pr-n">
                            <div className="story-img">
                                <img src={penale} alt=""/>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="story-text left-align-text">
                                <p></p>
                                <p></p>
                                <p></p>
                                <p></p>
                                <p>Lo Studio offre consulenza ed assistenza giudiziale in materia di diritto penale nelle seguenti aree di attività:</p>
                                <ul>
                                    <li>reati societari, tributari e fallimentari</li>
                                    <li>infortuni e sicurezza sui luoghi di lavoro</li>
                                    <li>reati in materia ambientale e violazioni edilizie</li>
                                    <li>tutela penale della proprietà industriale ed intellettuale</li>
                                    <li>tutela penale della reputazione sul web</li>
                                    <li><b>responsabilità penale</b> dell'esercente la professione sanitaria</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>

    )
}

export default Story;